import React, { PropsWithChildren } from "react"
import frills from "../../icon/frills.svg"
import { ReactComponent as Shadow } from "../../icon/shadow.svg"
import "../../css/BobbingIcon.css"

interface BobbingIconProps {
  horizontalOffset?: string
  verticalOffset?: string
}

function BobbingIcon({
  horizontalOffset,
  verticalOffset,
  children,
}: PropsWithChildren<BobbingIconProps>) {
  return (
    <div className="frillsContainer">
      <img
        src={frills}
        alt=""
      />
      <div
        className="bobbingIconContainer"
        style={{ marginLeft: horizontalOffset ?? "0px", marginTop: verticalOffset ?? "0px" }}
      >
        {children}
      </div>
      <div className="shadowContainer">
        <Shadow />
      </div>
    </div>
  )
}

export default BobbingIcon
